import { createFetcher } from "api/helpers"

const fetcherConfiguration = {
  method: "get",
  makeRequestUrl: (host, projectID) => {
    return `${host}/cp/${projectID}/cms_user_actions`
  },
  checkRequiredArguments: () => { },
  makeResponseData: (json) => {
    return json
  }
}
export default createFetcher(fetcherConfiguration)
